<template>
  <button
    type="button"
    class="hm-reload-btn"
    :class="{ 'hm-reload-btn--active': model, 'hm-reload-btn--disabled': isDisabled }"
    :disabled="isDisabled"
    @click="onClick"
  >
    <span class="hm-reload-btn__spinner"></span>
  </button>
</template>

<script>
export default {
  name: 'HMReloadButton',
  props: {
    value: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    model: {
      get() { return this.value },
      set(v) { this.$emit('input', v) }
    },
    isDisabled() {
      return this.disabled || this.model
    }
  },
  methods: {
    onClick() {
      if (this.isDisabled) return
      this.model = true
      this.$emit('start')
    }
  }
}
</script>

<style scoped>
.hm-reload-btn {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background: #DCEAF5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
  transition: filter .2s
}

.hm-reload-btn:hover:not(:disabled) {
  filter: brightness(.98)
}

.hm-reload-btn--disabled {
  cursor: default
}

.hm-reload-btn__spinner {
  position: relative;
  width: 20px;
  height: 20px
}

.hm-reload-btn__spinner::before {
  content: '';
  position: absolute;
  inset: 0;
  border: 2px solid #7aa2be;
  border-right-color: transparent;
  border-radius: 50%
}

.hm-reload-btn__spinner::after {
  content: '';
  position: absolute;
  right: 0;
  bottom: 12px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 3px 0 3px 5px;
  border-color: transparent transparent transparent #7aa2be;
  transform: rotate(40deg)
}

@keyframes hm-reload-spin {
  to { transform: rotate(360deg) }
}

.hm-reload-btn--active .hm-reload-btn__spinner {
  animation: hm-reload-spin 1s linear infinite
}
</style>
